import React from 'react';

const ReferenceContent = () => {
    return (
        <section className="privacy-policy-sec">
            <h2 className="mb-3">ezGUIDE References</h2>
            <div className="">
                <ul className="list-type-none">
                    <li className="sub-head">
                        <h3>American Clinical Neurophysiology Society (ACNS)</h3>
                        <p className="mb-3">
                            Guideline 1: Minimum Technical Requirements for Performing Clinical EEG.
                            <br />
                            <a href="https://www.acns.org/pdf/guidelines/Guideline-1.pdf" target="_blank">
                                Download PDF
                            </a>
                        </p>
                    </li>
                    <li className="sub-head">
                        <h3>Nuwer, M.R., et al. (1998)</h3>
                        <p className="mb-3">
                            IFCN guidelines for topographic and frequency analysis of EEGs and EPs.
                            <br />
                            <i>Electroencephalography and Clinical Neurophysiology</i>, 106(4), 259–261.
                            <br />
                            <span className="note">
                                This article is cited for informational and educational purposes. Full access may require an institutional subscription or academic library access.
                            </span>
                        </p>
                    </li>
                    <li className="sub-head">
                        <h3>Klem, G.H., et al. (1999)</h3>
                        <p className="mb-3">
                            The ten–twenty electrode system of the International Federation.
                            <br />
                            <i>Electroencephalography and Clinical Neurophysiology Supplement</i>, 52, 3–6.
                            <br />
                            <span className="note">
                                This article is cited for informational and educational purposes. Full access may require an institutional subscription or academic library access.
                            </span>
                        </p>
                    </li>
                </ul>
            </div>
        </section>
    );
};

export default ReferenceContent;